import {
  GET_ARTIST,
  CREATE_ARTIST,
  EDIT_ARTIST,
  DELETE_ARTIST,
  TOGGLE_ARTIST_ACTIVE,
} from "./artist.type";

const initialState = {
  artist: [],
};

const artistReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ARTIST:
      return {
        ...state,
        artist: action.payload,
      };
    case CREATE_ARTIST:
      return {
        ...state,
        artist: [action.payload, ...state.artist],
      };
    case EDIT_ARTIST:
    case TOGGLE_ARTIST_ACTIVE:
      return {
        ...state,
        artist: state.artist.map((artist) =>
          artist._id === action.payload.id ? action.payload.data : artist
        ),
      };
    case DELETE_ARTIST:
      return {
        ...state,
        artist: state.artist.filter(
          (artist) => artist._id !== action.payload
        ),
      };
    default:
      return state;
  }
};

export default artistReducer;
